import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=b407ed92&scoped=true"
import script from "./technology.vue?vue&type=script&lang=js"
export * from "./technology.vue?vue&type=script&lang=js"
import style0 from "./technology.vue?vue&type=style&index=0&id=b407ed92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b407ed92",
  null
  
)

export default component.exports